<div class="dialog">
    <div class="dialog-header">
        <h3 class="details-card-title">
            {{ 'INTERFACE|Informacje' | translate }}
        </h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <p [innerHTML]="data.info"></p>
    </div>
</div>
